<style>
.kSugcX {
    margin: 2rem 0.5rem;
    width: auto !important;
}
.firstprodctslick_prev {
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    position: absolute;
    top: 50%;
    right: auto;
    left: 10px;
    width: 25px;
    height: 25px;
    outline: none;
    cursor: pointer;
    opacity: 1;
    background-color: rgb(255, 255, 255);
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px 0px;
    border: 1px solid rgb(222, 222, 222);
    border-radius: 50%;
    transform: translate(0px, -50%);
}
.firstprodctslick_next {
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    position: absolute;
    top: 50%;
    right: 10px;
    left: auto;
    width: 25px;
    height: 25px;
    outline: none;
    cursor: pointer;
    opacity: 1;
    background-color: rgb(255, 255, 255);
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px 0px;
    border: 1px solid rgb(222, 222, 222);
    border-radius: 50%;
    transform: translate(0px, -50%) rotate(180deg);
}
.bDkRnC {
    box-shadow: rgba(0, 0, 0, 0.16) 0px 4px 16px 0px;
    border: none;
    background-color: rgb(255, 255, 255);
    border-radius: 16px;
    color: rgb(51, 51, 51);
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 1;
    height: 100%;
    cursor: pointer;
}
.kSugcX a {
    color: #222c9b;
    text-decoration: none;
    background-color: transparent;
    -webkit-text-decoration-skip: objects;
}
.ksHBQn {
    width: 88px;
    height: 128px;
    display: flex;
    flex-direction: column;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: start;
    justify-content: flex-start;
    gap: 0.5rem;
    padding: 0.5rem 0px;
}
@media (min-width: 62em){
    .ksHBQn {
        width: 128px;
        height: 160px;
        padding: 0.5rem 0px 0.75rem;
    }
}
.cMZsEA {
    height: 72px;
    width: 72px;
}
@media (min-width: 62em){
    .cMZsEA {
        height: 92px;
        width: 92px;
    }
}
.cMZsEA img {
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-user-drag: none;
    -moz-user-drag: none;
    max-width: 100%;
    height: auto;
    vertical-align: middle;
    border-style: none;
}
.cMZsEA > img {
    height: 100%;
    width: 100%;
    object-fit: contain;
}
@media (min-width: 62em){
.gGoeSo {
    font-size: 1rem;
    line-height: 1.25;
}
}
.gGoeSo {
    color: rgb(51, 51, 51);
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1;
    text-align: center;
    margin: auto 0.5rem;
    font-family: Poppins, sans-serif;
}
</style>
<template>
    <section class="featured-categories-wrap">
        <div class="container">
            <div class="tab-content first-category-firstproducts">
                <div v-for="product in firsttabproducts" :key="product.id" class="kSugcX"
                     v-if="product.is_in_stock && (!product.manage_stock || (product.manage_stock && product.qty > 0))">
                    <a :href="'/products/'+product.slug" class="bDkRnC">
                        <div class="ksHBQn">
                            <div class="cMZsEA">
                                <img :alt="product.name" loading="eager" width="96" height="96"
                                     :src="product.base_image.path" :srcset="product.base_image.path">
                            </div>
                            <span class="gGoeSo">{{ product.name }}</span>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: ['data'],

    data() {
        return {
            firsttabproducts: this.data || []
        };
    }
}
</script>
<script>
    import ProductCard from '../ProductCard.vue';
    // import DynamicTabsMixin from '../../mixins/DynamicTabsMixin';
    import { firstProductSlickPrevArrow, firstProductSlickNextArrow } from '../../functions';

    export default {

        // mixins: [
        //     DynamicTabsMixin,
        // ],
        // props: ['firstproducts'],
        data() {
            return {
                firsttabproducts: []
            };
        },
        mounted() {
            this.loading = true;
                $.ajax({
                    method: "GET",
                    url: '/it/storefront/featured-categories/1/products',
                    context: this
                }).then(async firsttabproduct => {
                    if (this.selector().hasClass('slick-initialized')) {
                        this.selector().slick('unslick');
                    }
                    this.loading = false;
                    this.firsttabproducts = firsttabproduct.filter(p => p.in_stock === true);

                    this.$nextTick(() => {
                        this.selector().slick(this.slickOptions());
                    });
                });
        },
        methods: {
            selector() {
                return $('.first-category-firstproducts');
            },

            slickOptions() {
                return {
                    rows: 0,
                    centerMode: false,
                    centerPadding: '60px',
                    dots: false,
                    arrows: true,
                    infinite: false,
                    slidesToShow: 12,
                    slidesToScroll: 3,
                    rtl: window.FleetCart.rtl,
                    // prevArrow: firstProductSlickPrevArrow(),
                    // nextArrow: firstProductSlickNextArrow(),
                    responsive: [
                        {
                            breakpoint: 1761,
                            settings: {
                                slidesToShow: 12,
                                slidesToScroll: 3,
                                arrows: true,
                                centerMode: false,
                                centerPadding: '40px',
                            },
                        },
                        {
                            breakpoint: 1301,
                            settings: {
                                slidesToShow: 8,
                                slidesToScroll: 8,
                                arrows: true,
                                centerMode: false,
                                centerPadding: '40px',
                            },
                        },
                        {
                            breakpoint: 1051,
                            settings: {
                                slidesToShow: 6,
                                slidesToScroll: 6,
                                arrows: true,
                                centerMode: false,
                                centerPadding: '40px',
                            },
                        },
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 5,
                                slidesToScroll: 5,
                                arrows: true,
                                centerMode: false,
                                centerPadding: '40px',
                            },
                        },
                        {
                            breakpoint: 881,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3,
                                arrows: true,
                                centerMode: false,
                                centerPadding: '40px',
                            },
                        },
                        {
                            breakpoint: 641,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                                arrows: false,
                                centerMode: false,
                                centerPadding: '40px',
                            },
                        },
                    ],
                };
            },
        },
    };
</script>
